import { CardContent, CardHeader, FormControl, FormControlLabel, FormHelperText, Grid2, IconButton, Stack, Switch } from "@mui/material"
import DashboardLayout from "../../../layoutcontainers/DashboardLayout"
import { ArrowBack } from "@mui/icons-material"
import MaterialTypography from "../../../components/MaterialTypography"
import { useNavigate, useSearchParams } from "react-router-dom"
import { useSnackbar } from "../../../context/popup"
import { useLoading } from "../../../components/Loading"
import MaterialInput from "../../../components/MaterialInput"
import { useOperationCategoryFormHandling } from "./components/OperationCategoryStateHandle.js";
import MaterialSelect from "../../../components/MasterSelect/index.js"
import MaterialBox from "../../../components/MaterialBox"
import MaterialButton from "../../../components/MaterialButton/index.js"
import { fetchData, fetchDataById, postData, putData } from "../../../services/index.js"
import { useEffect, useState } from "react"

const OperationCategoryForm = () => {

    const [searchParams] = useSearchParams();
    const operationCategoryId = searchParams.get("id");
    const pageType = searchParams.get("pageType");
    const pageMode = pageType === "view" ? "view" : pageType === "edit" ? "edit" : "add";
    const navigate = useNavigate();
    const { showSnackbar } = useSnackbar();
    const { setCircleLoading } = useLoading();

    const [parentKeyDropOptions, setParentKeyDropOptions] = useState([]);
    
    useEffect(() => {
        if((pageMode === "add") || (!operationCategoryId)){
            return
        }
        const fetchOperationCategoryDataById = async (operationCategoryId) => {
            setCircleLoading(true);
            try {
            const data = await fetchDataById(`/orchestration/key-value-category/${operationCategoryId}`);
            const responseData = data?.data;
            
            if(data?.success){
                setFormData(prev => ({
                ...prev,
                categoryName: responseData.categoryName || "",
                code: responseData.code || "",
                parentCategoryId: { label: responseData?.parentCategory?.categoryName, value: responseData?.parentCategory?.id },
                description: responseData?.description || "",
                isActive: responseData?.isActive,
                // reset status fields
                categoryNameStatus: responseData.categoryName ? "success" : "unchecked",
                codeStatus: responseData.code ? "success" : "unchecked",
                parentCategoryIdStatus: responseData?.parentCategory?.id ? "success" : "unchecked",
                descriptionStatus: responseData?.description ? "success" : "unchecked",
                }));
            }
            else{
                //throw error message
                showSnackbar(data?.message,'error');
            }
            } catch (error) {
                console.error('Error fetching data by ID:', error);
                showSnackbar(error?.response?.data?.message || "Network Error","error");
            }
            finally{
                setCircleLoading(false);
            }
        };
        fetchOperationCategoryDataById(operationCategoryId);
    },[pageMode]);

    useEffect(() => {
        if(pageMode === "view"){
            return
        }
        fetchParentKeyData();
    }, []);

    const fetchParentKeyData = async () => {
        setCircleLoading(true);
        try{
            const response = await fetchData(`/orchestration/key-value-category?dropdown=true&isActive=true`);            
            if(response?.success){
                const formattedCategories = response?.data?.items?.map((item) => ({
                    value: item?.id,
                    label: item?.categoryName,
                })) || [];
                setParentKeyDropOptions(formattedCategories);
            }
        }
        catch(error){
            console.error("Error Fetching Pareny Key Data:",error);
            showSnackbar("Error Fetching Parent Key Data","warning");
        }
        finally{
            setCircleLoading(false);
        }
    };

    const handleSubmitOperationCategory = async () => {
        const payload = {
            code: formData?.code,
            categoryName: formData?.categoryName,
            description: formData?.description,
            parentCategoryId: formData?.parentCategoryId?.value,
            isActive: formData?.isActive
        };
        //Update
        if(operationCategoryId){
            setCircleLoading(true);
            try {
                const response = await putData(`/orchestration/key-value-category/${operationCategoryId}`, payload);
                
                const responseMessage = response?.message;
                if(response?.success){
                //success message
                    showSnackbar(responseMessage, "success");
                    navigate('/operation/operation-category');          
                }
                else{
                    //error message
                    showSnackbar(responseMessage, "error")
                }
            } catch (error) {
                console.error('Error updating data:', error);
                showSnackbar(error?.response?.data?.message || "Network Error","error")
            }
            finally{
                setCircleLoading(false);
            }
        }
        else{      
        //Submit
            setCircleLoading(true);
            try {
                const response = await postData('/orchestration/key-value-category', payload);
                
                const responseMessage = response?.message;
                if(response?.success){
                    //success message
                    showSnackbar(responseMessage, "success");
                    navigate('/operation/operation-category');          
                }
                else{
                    //error message
                    showSnackbar(responseMessage, "error");
                }
            } catch (error) {
                //catch error message
                console.error('Error posting data:', error);
                showSnackbar(error?.response?.data?.message || "Network Error","error");
            }
            finally{
                setCircleLoading(false);
            }
        }
    };

    const { formData, setFormData, handleChange, checkAllFields } = useOperationCategoryFormHandling(); 

  return (
    <DashboardLayout>
        <CardHeader
        title={
            <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            spacing={2}
            >
                <Stack direction="row" alignItems="center" spacing={1}>
                    <IconButton onClick={() => navigate("/operation/operation-category")}>
                        <ArrowBack />
                    </IconButton>
                    <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h5" fontWeight="medium">
                        Opeation Category Details
                    </MaterialTypography>
                    <MaterialTypography variant="caption" color="text">
                        Enter New Opeation Category Details.
                    </MaterialTypography>
                    </Stack>
                </Stack>
            </Stack>
        }
        />
        <CardContent>
            <Grid2 container spacing={1} alignItems="center">
                <Grid2 size={{ xs: 12, sm: 6 }}>
                    <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                    >
                    Category Name*
                    </MaterialTypography>
                    <MaterialInput
                        name="categoryName"
                        placeholder="eg. category name"
                        value={formData.categoryName}
                        onChange={handleChange}
                        error={formData.categoryNameStatus === "error" ? true : false}
                        success={formData.categoryNameStatus === "success" ? true : false}
                        disabled={pageMode === "view"}
                    />
                    {formData.categoryNameStatus === "error" && (
                        <FormControl error>
                        <FormHelperText>
                            Name should be maximum 20 characters long and can contain
                            only alphabets
                        </FormHelperText>
                        </FormControl>
                    )}
                </Grid2>

                <Grid2 size={{ xs: 12, sm: 6 }}>                    
                    <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                    >
                    Category Code*
                    </MaterialTypography>
                    <MaterialInput
                        name="code"
                        placeholder="eg. category code"
                        value={formData.code}
                        onChange={handleChange}
                        error={formData.codeStatus === "error" ? true : false}
                        success={formData.codeStatus === "success" ? true : false}
                        disabled={pageMode === "view"}
                    />
                    {formData.codeStatus === "error" && (
                        <FormControl error>
                        <FormHelperText>
                            Category Code must contain only uppercase letters (A-Z) and
                            underscores (_)
                        </FormHelperText>
                        </FormControl>
                    )}
                </Grid2>

                <Grid2 size={{ xs: 12, sm: 6 }}>
                    <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                    >
                    Description
                    </MaterialTypography>
                    <MaterialInput
                        name="description"
                        placeholder="eg. category description"
                        value={formData.description}
                        onChange={handleChange}
                        error={formData.descriptionStatus === "error" ? true : false}
                        success={formData.descriptionStatus === "success" ? true : false}
                        disabled={pageMode === "view"}
                    />
                    {formData.descriptionStatus === "error" && (
                        <FormControl error>
                        <FormHelperText>
                            Description should be maximum 100 characters long and can
                            contain only alphabets
                        </FormHelperText>
                        </FormControl>
                    )}
                </Grid2>

                <Grid2 size={{ xs: 12, sm: 6 }}>
                    <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                    >
                    Parent Key
                    </MaterialTypography>
                    <MaterialSelect
                        name="parentCategoryId"
                        value={formData.parentCategoryId}
                        options={parentKeyDropOptions}
                        onChange={handleChange}
                        error={formData.parentCategoryIdStatus === "error" ? true : false}
                        success={formData.parentCategoryIdStatus === "success" ? true : false}
                        isDisabled={pageMode === "view"}
                    />
                </Grid2>

                <Grid2 size={{ xs: 12, sm: 2 }}>
                    <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                    >
                    Active
                    </MaterialTypography>
                    <FormControlLabel
                        control={
                        <Switch
                            name="isActive"
                            checked={formData.isActive}
                            onChange={(event) =>
                            handleChange({
                                target: {
                                name: "isActive",
                                value: event.target.checked,
                                },
                            })
                            }
                            color="primary"
                        />
                        }
                        label={
                        <MaterialTypography variant="caption" fontWeight="bold">
                            {formData?.isActive ? "Active" : "Inactive"}
                        </MaterialTypography>
                        }
                        sx={{ marginLeft: 0 }}
                        disabled={pageMode === "view"}
                    />
                </Grid2>
            </Grid2>
        </CardContent>
        <MaterialBox
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        >
            {pageMode !== "view" && (
            <>
                <MaterialButton
                sx={{ m: 2 }}
                variant="outlined"
                color="dark"
                onClick={() => navigate("/operation/operation-category")}
                >
                Cancel
                </MaterialButton>
                <MaterialButton
                sx={{ m: 2 }}
                variant="gradient"
                color="dark"
                disabled={!checkAllFields()}
                onClick={handleSubmitOperationCategory}
                >
                {pageMode === "edit" ? "Update" : "Submit"}
                </MaterialButton>
            </>
            )}
        </MaterialBox>
    </DashboardLayout>
  )
}

export default OperationCategoryForm